import * as Sentry from "@sentry/react";

import type { WebViewMessage } from "@/shared/lib";

export const sendMessageToReactNativeWebView = (message: WebViewMessage) => {
  try {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: message.type },
      tags: { feature: "sendMessageToReactNativeWebView" },
    });
  }
};
